import React from "react";
import { useNavigate } from "react-router-dom";
import { Chip } from "@mui/material";

// Internal imports
import "./UserProfilePopper.scss";
import { browserSupportsWebAuthn } from "@simplewebauthn/browser";

type UserProfilePopperProps = {
  firstName: string;
  lastName: string;
  email: string;
  role: string;
  vendorType: string;
  handledClickedItem: () => void;
};

export const UserProfilePopper = ({
  firstName,
  lastName,
  email,
  vendorType,
  handledClickedItem,
  role,
}: UserProfilePopperProps) => {
  const navigate = useNavigate();

  const handleLogout = () => {
    handledClickedItem();
    navigate("/logout");
  };

  return (
    <div className="user-profile-container">
      <div className="name-email">
        <h6 className="user-name">
          {" "}
          {firstName} {lastName || ""}
        </h6>
        <p className="user-email">{email}</p>
        <Chip
          label={vendorType || role}
          style={{ marginTop: "5px", marginLeft: "-0.5rem" }}
        />
      </div>
      <hr className="popper-hr-line" />
      <div className="user-profile-opt">
        <li className="user-opt" onClick={handledClickedItem}>
          User Profile
        </li>
        {browserSupportsWebAuthn() && (
          <li
            className="user-opt"
            onClick={() => {
              navigate("/settings");
            }}
          >
            Settings
          </li>
        )}
      </div>
      <hr className="popper-hr-line" />
      <li className="logout" onClick={handleLogout}>
        Logout
      </li>
    </div>
  );
};
